/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import { useEffectOnce } from "usehooks-ts";
import { css } from "@emotion/react";
import { GlobalStore } from "../../store/global/GlobalStore";

export const RandomMessage: React.FC = props => {
  const theme = GlobalStore.useState(s => s.theme);
  const scrollTwitterMessage = () => {
    return (
      <>
        Want some entertainment while you wait for your transaction to complete? Scroll through our{" "}
        <a href="https://twitter.com/bebop_dex" target="_blank" rel="noreferrer nofollow">
          Twitter
        </a>
        .
      </>
    );
  };
  const jazzMessage = () => {
    return <>Did you know that bebop is a style of Jazz?</>;
  };
  const saveMessage = () => {
    return (
      <>
        You can save up to 60% in gas fees per token pair with our multi-token trading.{" "}
        <a
          href="https://medium.com/bebop-dex/how-much-are-you-really-saving-on-gas-with-bebops-multi-token-trading-3e9ff2251bf9"
          target="_blank"
          rel="noreferrer nofollow"
        >
          Learn more
        </a>
        .
      </>
    );
  };
  const networkFeeMessage = () => {
    return (
      <>
        Your network fees are already included in the price you see on Bebop.{" "}
        <a
          href="https://medium.com/bebop-dex/what-are-gas-fees-and-why-dont-you-need-eth-to-trade-on-ethereum-with-bebop-f3b0202332be"
          target="_blank"
          rel="noreferrer nofollow"
        >
          Learn more
        </a>
        .
      </>
    );
  };
  const slippageMessage = () => {
    return (
      <>
        On Bebop, you have 0 slippage on all of your trades.{" "}
        <a
          href="https://medium.com/bebop-dex/how-does-bebop-offer-zero-slippage-and-what-does-this-mean-116940c467ce"
          target="_blank"
          rel="noreferrer nofollow"
        >
          Learn more
        </a>
        .
      </>
    );
  };
  const swapManyMessage = () => {
    return (
      <>
        Swap up to five tokens to one or one to five directly on Bebop!{" "}
        <a
          href="https://medium.com/bebop-dex/how-much-are-you-really-saving-on-gas-with-bebops-multi-token-trading-3e9ff2251bf9"
          target="_blank"
          rel="noreferrer nofollow"
        >
          Learn more
        </a>
        .
      </>
    );
  };
  const feedbackMessage = () => {
    return (
      <>
        Have feedback for us? Join our{" "}
        <a href="https://discord.com/invite/bebop" target="_blank" rel="noreferrer nofollow">
          Discord
        </a>{" "}
        or let us know in the chat here.
      </>
    );
  };
  const faqsMessage = () => {
    return (
      <>
        Read through{" "}
        <a href="https://help.bebop.xyz/en/" target="_blank" rel="noreferrer nofollow">
          our FAQs
        </a>{" "}
        to learn more about Bebop
      </>
    );
  };

  const messages = [
    scrollTwitterMessage(),
    jazzMessage(),
    saveMessage(),
    networkFeeMessage(),
    slippageMessage(),
    swapManyMessage(),
    feedbackMessage(),
    faqsMessage(),
  ];
  const [message, setMessage] = useState(messages[Math.floor(Math.random() * messages.length)]);

  useEffectOnce(() => {
    setMessage(messages[Math.floor(Math.random() * messages.length)]);
  });

  return (
    <p
      className="text-secondary p-2"
      css={css`
        font-family: ${theme.fontFamilies["work-sans"]};
        font-size: ${theme.fontSize["5"]};
      `}
    >
      {message}
    </p>
  );
};
